import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";

import './VenueEvent.scss';

export const AdministratorVenueEventStatuses = (props) => {
    const dispatch = useDispatch();

    const [venueEventStatuses, setVenueEventStatuses] = useState([]);
    const [venueEventStatusCount, setVenueEventStatusCount] = useState(0);
    const [skipCount, setSkipCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(1);
    const [areVenueEventStatusesLoading, setAreVenueEventStatusesLoading] = useState(true);
    const [loadingError, setLoadingError] = useState("");

    const getVenueEventStatuses = (newPageNumber) => {
        setAreVenueEventStatusesLoading(true);

        const dataItem = {
            venueEventKey: props.venueEventKey,
            pageNumber: newPageNumber,
        };
    
        fetch(`/api/administrator/venueeventstatuses`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setAreVenueEventStatusesLoading(false);                
                setItemsPerPage(result.venueEventStatusesPerPage);
                setSkipCount(result.venueEventStatusesPerPage * (result.pageNumber - 1));
                setVenueEventStatusCount(result.totalVenueEventStatusCount);                
                setVenueEventStatuses(result.venueEventStatuses);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setAreVenueEventStatusesLoading(false);
                setLoadingError(error.message);
            });
    }

    const pageChange = (event) => {
        const newPageNumber = (event.page.skip / event.page.take) + 1;
        getVenueEventStatuses(newPageNumber);
    };

    useEffect(() => {
        if (props.venueEventKey) {
            getVenueEventStatuses();
        }
    }, []);

    return (
        <div>
            {areVenueEventStatusesLoading ? <LoadingPanel /> : (loadingError === "" ? (
                <>
                    <Grid
                        data={venueEventStatuses}
                        resizable={true}
                        skip={skipCount}
                        take={itemsPerPage}
                        total={venueEventStatusCount}
                        pageable={true}
                        onPageChange={pageChange}
                        scrollable="none"
                    >
                        <Column field="dateCreated" title={"Date"} />
                        <Column field="oldVenueEventStatusTypeName" title={"Old Status"} />
                        <Column field="newVenueEventStatusTypeName" title={"New Status"} />
                    </Grid>
                </>
            ) : <></>)
            }
        </div>
    );
}